import { useQuery } from "@tanstack/vue-query";
import Dialer from "@/services/dialer/dialer";
import type { ActiveDialerSession } from "@/dtos/Dialer.dto";

export function useActiveDialerSession() {
  return useQuery({
    queryKey: ["dialerSession", "active"],
    queryFn: async (): Promise<ActiveDialerSession | null> => {
      const result = await Dialer.getActiveSession();
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to load active dialer session");
      }
      return result.data.data;
    },
  });
}
